import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER } from 'reactApp/appHelpers/configHelpers';

const condition = !IS_BIZ_USER && !IS_CORP_USER;

export const upgradeSubscriptionEnabled = condition && getFeature('upgrade-subscription');
export const upgradeSubscriptionWebviewEnabled = condition && getFeature('upgrade-subscription-webview');
